import styled from "styled-components"

import { minWidth } from "utils"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  padding: 2rem 1.6rem;
  background: #efeee9;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 3rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 4rem;
  `}
`

export const Title = styled.h2`
  padding-bottom: 0.6rem;
  border-bottom: 0.1rem solid #222;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  line-height: 1.36;
`

export const Expert = styled.div`
  margin-top: 1.6rem;
  font-size: 18px;
  line-height: 1.33;

  .review-author-name {
    font-weight: 500;
    text-decoration: underline;
  }
`
